<section class="page-container">
    <div class="flex items-center justify-between">
      <h1 class="main-heading">Model and Specification</h1>
      <app-navpath />
    </div>
    <div class="mb-2 flex w-fit gap-1">
      <button class="shorter-btn darker-primary-btn">
        <fa-icon [icon]="faPlus" class="mr-1"></fa-icon>Add
      </button>
      <button class="shorter-btn red-btn">
        <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>Delete
      </button>
      <app-table-search-input (childInput)="searchInput = $event" />
    </div>
    <div class="content-container">
      <app-data-table
        [tableHeaders]="tableHeaders"
        [tableEntries]="specifications"
        [searchInput]="searchInput"
      />
    </div>
  </section>

